import { observer } from "@legendapp/state/react";
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Category } from "../../../pages/category/Category";
import HomePage from "../../../pages/home/Home.page";
import PrimaryLayout from "../../../pages/primary-layout/PrimaryLayout.page";
import { state$ } from "../../../state";
import { INavPaths } from "../../../state/staticItems";
import useDarkModeSetup from "../../../tools/hooks/darkmode.hook";
import useWindowResize from "../../../tools/hooks/useWindowResize.hook";
import OverlayLoader from "../../ui/overlay-loader/OverlayLoader";
import "./../../../assets/styles/theme.scss";

const Base = observer(() => {
    useDarkModeSetup();

    useWindowResize(() => {
        //TODO use this later on for mobile / responsive purposes
    });

    const boostrapState = state$.settings.isAppBootstrapped.get();
    useEffect(() => {
        state$.settings.isAppBootstrapped.set(true);
    }, [])

    return (
        boostrapState ?

            <div className="app-container">
                {/* <Helmet>
                    <title>Syon Lane - Home</title>
                    <meta httpEquiv='cache-control' content='no-cache' />
                    <meta httpEquiv='expires' content='0' />
                    <meta httpEquiv='pragma' content='no-cache' />
                </Helmet> */}

                <Routes>
                    <Route path="/" element={<PrimaryLayout />}>
                        {/**===Home Routing*/}
                        <Route index element={<HomePage />} />

                        <Route path={`${INavPaths.CORE_DOCUMENTS}/*`} element={<Category />} />
                        <Route path={`${INavPaths.INQUIRY_DOCUMENTS}/*`} element={<Category />} />

                        {/** ===404 Routing*/}
                        <Route path="*" element={<>NOT FOUND!</>} />
                    </Route>
                </Routes>

                {/**
         Notifications wrapper
         */}

            </div >
            : <OverlayLoader />
    )
})

export default Base;